import React from 'react';
import { Row, Col, Table, Card, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';
import BootstrapTable from 'react-bootstrap-table-next';
import './Line.css';

const ListingReportsVendorContacts = ({
  reports,
  reportsExp,
  filters,
  stateFilters,
  handleFilterChange,
  load
}) => {
  const { t } = useTranslation();

  const handlePageChange = (page) => handleFilterChange({ page });

  let detailsArray = [];

  const getRowContacts = (contacts, id) => {
    if (contacts.length == 0)
      return (
        <div className="container">
          <div className="row">
            <div className="col-sm text-center align-middle">
              {t(`error:sem contato`)}
            </div>
          </div>
        </div>
      );
    let contacts_list = contacts.map((contact) => (
      <tr>
        <td>{contact.name}</td>
        <td>{contact.email}</td>
        <td>{contact.job}</td>
        <td>{contact.phone}</td>
        <td>{contact.cell_phone}</td>
      </tr>
    ));
    return (
      <Table bordered hover responsive id={id}>
        <thead>
          <tr>
            <th>{t(`label:name`)}</th>
            <th style={{ width: '27%' }}>{t(`label:email`)}</th>
            <th>{t(`label:job`)}</th>
            <th style={{ width: '13%' }}>{t(`label:phone`)}</th>
            <th style={{ width: '13%' }}>{t(`label:cell phone`)}</th>
          </tr>
        </thead>
        <tbody>{contacts_list}</tbody>
      </Table>
    );
  };

  const getDetails = (rowId) => {
    detailsArray = [];
    {
      reports.data.map((report) => {
        var detail = {
          id: report.id,
          contacts: [],
        };
        report.contacts.map((contact) => {
          detail.contacts.push({
            name: contact.name,
            email: contact.email,
            job: contact.job,
            phone: contact.phone,
            cell_phone: contact.cell_phone,
          });
        });

        if (report.id === rowId) {
          detailsArray.push(detail);
        }
      });
    }
  };

  const columns = [
    {
      dataField: 'btn1',
      text: '',
      headerStyle: {
        width: '4%',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'name',
      text: t('label:company name'),
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'alias',
      text: 'Nome Fantasia',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'document',
      text: 'CNPJ',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'btn2',
      text: '',
      headerStyle: {
        width: '4%',
      },
      style: {
        textAlign: 'center',
      },
    },
  ];
  const columnsExp = [
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'email',
      text: 'Email',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'alias',
      text: 'Empresa',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'phone',
      text: 'Telefone',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'cell_phone',
      text: 'Celular',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
  ];

  const btn_move = (id) => {
    var btn1 = document.getElementById('btn-' + id + '-1');
    var btn2 = document.getElementById('btn-' + id + '-2');
    if (!btn1.className.includes('down') && !btn2.className.includes('down')) {
      btn1.className = btn1.className.replace('right', 'down');
      btn2.className = btn2.className.replace('left', 'down');
    } else {
      btn1.className = btn1.className.replace('down', 'right');
      btn2.className = btn2.className.replace('down', 'left');
    }
  };

  const expandRow = {
    renderer: (row) => (
      <>
        {getDetails(row.id)}
        {btn_move(row.id)}
        {detailsArray.map((info) => getRowContacts(info.contacts, info.id))}
      </>
    ),
  };

  function btn1(id) {
    id = 'btn-' + id + '-1';
    return <i className="fas fa-angle-right" id={id}></i>;
  }
  function btn2(id) {
    id = 'btn-' + id + '-2';
    return <i className="fas fa-angle-left" id={id}></i>;
  }

  const reportsData = [];
  const reportsDataExp = [];

  function getReports() {
    let teste = [];
    reports.data.map((report) => {
      teste = reportsData.push({
        id: report.id,
        alias: report.alias,
        document: report.document,
        btn1: btn1(report.id),
        btn2: btn2(report.id),
        name: report.name,
      });
    });
    reportsExp.data.map((report) => {
      report.contacts.map((contact) => {
        teste = reportsDataExp.push({
          id: contact.id,
          name: contact.name,
          email: contact.email,
          alias: report.alias,
          phone: contact.phone,
          cell_phone: contact.cell_phone,
        });
      });
    });
  }

  getReports();

  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => (
              <Col key={k} md={3}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={(e) =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1,
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={(e) =>
                    handleFilterChange({ per_page: e.target.value, page: 1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.search}
                  onChange={(e) =>
                    handleFilterChange({ search: e.target.value, page: 1 })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <BootstrapTable
                id=""
                keyField="id"
                data={reportsData}
                columns={columns}
                expandRow={expandRow}
                classes="table-condensed"
                wrapperClasses='table-responsive'
              />
            </Col>
          </Row>
          <Row style={{ display: 'none' }}>
            <Col>
              <BootstrapTable
                id="table-to-xls"
                keyField="id"
                data={reportsDataExp}
                columns={columnsExp}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.from || '0' }} to{' '}
                {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.current_page}
                itemsCountPerPage={reports.per_page}
                totalItemsCount={reports.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingReportsVendorContacts;
